import React, { useEffect, useState } from "react";
import HierarchyDisplay from "./UnderMeterElements/TransformerArea";
import EnergyCard from "./UnderMeterElements/EnergyCard";
import Readings from "./UnderMeterElements/Readings";
import { filterByControlDate, filterByExpirationYear, filterByProductionYear } from "./YearFilter";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import "./LV.css";
import useSync3DLayers from "../../../utils/useSync3DLayers";
import { toggleLayerHelper, handleSidebarClose } from "../layersUtils";

const currentYear = new Date().getFullYear();

function LowVoltage({
    setWfsLayers,
    setHoverInfo,
    handleClickInfo,
    setWmsLayers,
    handleSidebarToggle,
    handleSubstationOptions,
    substationOptions = {
        broj_korisnika_ts: { checked: false },
        saidi_ts: { checked: false },
        saifi_ts: { checked: false },
        aktivne_ts: { checked: false },
        gubici_ts: { checked: false },
    },
    closeSidebar,
    wfsLayers,
    viewState,
    setViewState,
    setIsTrafoActive,
    setOverlay,
    id_terenske_jedinice,
    setIsOhActiveExtern,
    setNetworkType,
}) {
    const [isBrojilaActive, setIsBrojilaActive] = useState(false);
    const [isTrafostaniceActive, setIsTrafostaniceActive] = useState(false);
    const [isEnergetskaKarticaActive, setIsEnergetskaKarticaActive] = useState(false);
    const [isOcitanjaActive, setIsOcitanjaActive] = useState(false);
    const [isTrafopodrucjaActive, setIsTrafopodrucjaActive] = useState(false);
    const [productionYearRange, setProductionYearRange] = useState([1950, currentYear]);
    const [verificationYearRange, setVerificationYearRange] = useState([1950, currentYear]);
    const [sealExpiryYearRange, setSealExpiryYearRange] = useState([1950, currentYear]);
    const [showProductionYearSlider, setShowProductionYearSlider] = useState(false);
    const [showVerificationYearSlider, setShowVerificationYearSlider] = useState(false);
    const [showSealExpiryYearSlider, setShowSealExpiryYearSlider] = useState(false);
    const [checkTrafo, setCheckTrafo] = useState(false);

    const netType = "niskonaponska";

    useEffect(() => {
        setNetworkType(netType);
    }, [netType]);

    useEffect(() => {
        const hasTrafostanice = wfsLayers.some(layer => layer.id.startsWith("trafo_stanice"));
        setIsTrafostaniceActive(hasTrafostanice);
    }, [wfsLayers]);

    useEffect(() => {
        handleSubstationOptions({
            broj_korisnika_ts: { checked: false },
            saidi_ts: { checked: false },
            saifi_ts: { checked: false },
            aktivne_ts: { checked: false },
            gubici_ts: { checked: false },
        });
    }, []);

    useEffect(() => {
        if (isTrafopodrucjaActive) {
            handleSidebarToggle(() => (
                <HierarchyDisplay
                    isBrojilaActive={isBrojilaActive}
                    wfsLayers={wfsLayers}
                    setWfsLayers={setWfsLayers}
                    setHoverInfo={setHoverInfo}
                    handleClickInfo={handleClickInfo}
                    setWmsLayers={setWmsLayers}
                    viewState={viewState}
                    setViewState={setViewState}
                    id_terenske_jedinice={id_terenske_jedinice}
                />
            ));
        } else if (isBrojilaActive && !isTrafopodrucjaActive && isTrafostaniceActive) {
            handleSidebarClose({
                checkFlag: checkTrafo,
                setFlags: [setIsTrafopodrucjaActive],
                layerPrefixes: ["vod", "trafo"],
                setWfsLayers,
                setWmsLayers,
                closeSidebar,
                handleSidebarToggle,
            });
        }
    }, [isTrafopodrucjaActive, wfsLayers]);

    useEffect(() => {
        setIsTrafoActive(isTrafopodrucjaActive);
    }, [isTrafopodrucjaActive]);

    useSync3DLayers({
        wfsLayers,
        setWfsLayers,
        setWmsLayers,
        setHoverInfo,
        handleClickInfo,
        viewState,
        setViewState,
        setOverlay,
        id_terenske_jedinice,
        netType,
    });

    const handleChange = (value, setRange) => setRange(value);

    const toggleLayer = (checked, name, type) =>
        toggleLayerHelper({
            checked,
            layerName: name,
            networkType: type,
            wfsLayers,
            setWfsLayers,
            setWmsLayers,
            setHoverInfo,
            handleClickInfo,
            viewState,
            setViewState,
            setOverlay,
            id_terenske_jedinice,
            setNetworkType,
        });

    const updateSubstationOptions = (changedKey, checked) => {
        handleSubstationOptions({
            broj_korisnika_ts: {
                checked:
                    changedKey === "broj_korisnika_ts"
                        ? checked
                        : substationOptions?.broj_korisnika_ts?.checked || false,
            },
            saidi_ts: {
                checked:
                    changedKey === "saidi_ts"
                        ? checked
                        : substationOptions?.saidi_ts?.checked || false,
            },
            saifi_ts: {
                checked:
                    changedKey === "saifi_ts"
                        ? checked
                        : substationOptions?.saifi_ts?.checked || false,
            },
            aktivne_ts: {
                checked:
                    changedKey === "aktivne_ts"
                        ? checked
                        : substationOptions?.aktivne_ts?.checked || false,
            },
            gubici_ts: {
                checked:
                    changedKey === "gubici_ts"
                        ? checked
                        : substationOptions?.gubici_ts?.checked || false,
            },
        });
    };

    return (
        <div className="low-voltage">
            <span>
                <h5>Niskonaponska mreža</h5>
            </span>

            <div className="section">
                <label className="toggle">
                    <span>Stubovi</span>
                    <input
                        type="checkbox"
                        checked={
                            wfsLayers.some(layer => layer.id.startsWith("stubovi-niskonaponska")) ||
                            wfsLayers.some(layer => layer.id.startsWith("stubovi-niskonaponska-3d"))
                        }
                        onChange={(e) => {
                            toggleLayer(e.target.checked, "stubovi", "niskonaponska");
                        }}
                    />
                    <span className="slider"></span>
                </label>

                <label className="toggle">
                    <span>Dalekovodi</span>
                    <input
                        type="checkbox"
                        checked={
                            wfsLayers.some(layer => layer.id.startsWith("vod-niskonaponska")) ||
                            wfsLayers.some(layer => layer.id.startsWith("dionica-niskonaponska"))
                        }
                        onChange={(e) => {
                            toggleLayer(e.target.checked, "vod", "niskonaponska");
                        }}
                    />
                    <span className="slider"></span>
                </label>

                <div className="section">
                    <label className="toggle">
                        <span>Trafostanice</span>
                        <input
                            type="checkbox"
                            checked={wfsLayers.some(layer => layer.id.startsWith("trafo_stanice"))}
                            onChange={(e) => {
                                toggleLayer(e.target.checked, "trafo_stanice");
                                setIsTrafostaniceActive(e.target.checked);
                            }}
                        />
                        <span className="slider"></span>
                    </label>

                    {isTrafostaniceActive && (
                        <div className="trafostanice-options">
                            <label className="toggle">
                                <span>Broj korisnika TS</span>
                                <input
                                    type="checkbox"
                                    checked={substationOptions?.broj_korisnika_ts?.checked || false}
                                    onChange={(e) =>
                                        updateSubstationOptions("broj_korisnika_ts", e.target.checked)
                                    }
                                />
                                <span className="slider"></span>
                            </label>

                            <label className="toggle">
                                <span>Pouzdanost distrib. sistema</span>
                            </label>

                            <div className="nested-section">
                                <label className="toggle">
                                    <span>SAIDI (Dalekovod/TS)</span>
                                    <input
                                        type="checkbox"
                                        checked={substationOptions?.saidi_ts?.checked || false}
                                        onChange={(e) =>
                                            updateSubstationOptions("saidi_ts", e.target.checked)
                                        }
                                    />
                                    <span className="slider"></span>
                                </label>

                                <label className="toggle">
                                    <span>SAIFI (Dalekovod/TS)</span>
                                    <input
                                        type="checkbox"
                                        checked={substationOptions?.saifi_ts?.checked || false}
                                        onChange={(e) =>
                                            updateSubstationOptions("saifi_ts", e.target.checked)
                                        }
                                    />
                                    <span className="slider"></span>
                                </label>
                            </div>

                            <label className="toggle">
                                <span>Očitavanje brojila TS</span>
                                <input
                                    type="checkbox"
                                    checked={substationOptions?.aktivne_ts?.checked || false}
                                    onChange={(e) =>
                                        updateSubstationOptions("aktivne_ts", e.target.checked)
                                    }
                                />
                                <span className="slider"></span>
                            </label>

                            <label className="toggle">
                                <span>Gubici na TS</span>
                                <input
                                    type="checkbox"
                                    checked={substationOptions?.gubici_ts?.checked || false}
                                    onChange={(e) =>
                                        updateSubstationOptions("gubici_ts", e.target.checked)
                                    }
                                />
                                <span className="slider"></span>
                            </label>
                        </div>
                    )}
                </div>

                <label className="toggle">
                    <span>Brojila</span>
                    <input
                        type="checkbox"
                        checked={wfsLayers.some(layer => layer.id.startsWith("mjerna_mjesta"))}
                        onChange={async (e) => {
                            e.persist();
                            await toggleLayer(e.target.checked, "mjerna_mjesta");
                            setIsBrojilaActive(e.target.checked);
                        }}
                    />
                    <span className="slider"></span>
                </label>

                {isBrojilaActive && (
                    <div className="brojila-options">
                        <label className="toggle">
                            <span>Trafopodručja</span>
                            <input
                                type="checkbox"
                                onChange={(e) => {
                                    setIsTrafopodrucjaActive(e.target.checked);
                                    setCheckTrafo(true);
                                }}
                            />
                            <span className="slider"></span>
                        </label>

                        <label className="toggle">
                            <span>Baždarenje brojila</span>
                        </label>

                        <div className="sub-options">
                            <label className="toggle">
                                <span>Godina proizvodnje</span>
                                <input
                                    type="checkbox"
                                    onChange={(e) => {
                                        setShowProductionYearSlider(e.target.checked);
                                        if (!e.target.checked) {
                                            setWfsLayers(prevLayers =>
                                                prevLayers.filter(
                                                    layer =>
                                                        layer.id !==
                                                        "filtered-by-production-year-mjerna-mjesta-layer"
                                                )
                                            );
                                        }
                                    }}
                                />
                                <span className="slider"></span>
                            </label>

                            {showProductionYearSlider && (
                                <div className="slider-container">
                                    <Slider
                                        range
                                        min={1950}
                                        max={currentYear}
                                        step={1}
                                        value={productionYearRange}
                                        onChange={(value) => {
                                            handleChange(value, setProductionYearRange);
                                            filterByProductionYear(wfsLayers, productionYearRange, setWfsLayers);
                                        }}
                                        trackStyle={[{ backgroundColor: "#00ffcc" }]}
                                        handleStyle={[
                                            { backgroundColor: "#fff", borderColor: "#ccc" },
                                            { backgroundColor: "#fff", borderColor: "#ccc" },
                                        ]}
                                        railStyle={{ backgroundColor: "#34495e" }}
                                    />

                                    <div className="labels">
                                        <span>{productionYearRange[0]}</span>
                                        <span>{productionYearRange[1]}</span>
                                    </div>
                                </div>
                            )}

                            <label className="toggle">
                                <span>Godina ovjere</span>
                                <input
                                    type="checkbox"
                                    onChange={(e) => {
                                        setShowVerificationYearSlider(e.target.checked);
                                        if (!e.target.checked) {
                                            setWfsLayers(prevLayers =>
                                                prevLayers.filter(
                                                    layer =>
                                                        layer.id !==
                                                        "filtered-by-control-date-mjerna-mjesta-layer"
                                                )
                                            );
                                        }
                                    }}
                                />
                                <span className="slider"></span>
                            </label>

                            {showVerificationYearSlider && (
                                <div className="slider-container">
                                    <Slider
                                        range
                                        min={1950}
                                        max={currentYear}
                                        step={1}
                                        value={verificationYearRange}
                                        onChange={(value) => {
                                            handleChange(value, setVerificationYearRange);
                                            filterByControlDate(wfsLayers, verificationYearRange, setWfsLayers);
                                        }}
                                        trackStyle={[{ backgroundColor: "#00ffcc" }]}
                                        handleStyle={[
                                            { backgroundColor: "#fff", borderColor: "#ccc" },
                                            { backgroundColor: "#fff", borderColor: "#ccc" },
                                        ]}
                                        railStyle={{ backgroundColor: "#34495e" }}
                                    />

                                    <div className="labels">
                                        <span>{verificationYearRange[0]}</span>
                                        <span>{verificationYearRange[1]}</span>
                                    </div>
                                </div>
                            )}

                            <label className="toggle">
                                <span>Godina isteka žiga</span>
                                <input
                                    type="checkbox"
                                    onChange={(e) => {
                                        setShowSealExpiryYearSlider(e.target.checked);
                                        if (!e.target.checked) {
                                            setWfsLayers(prevLayers =>
                                                prevLayers.filter(
                                                    layer =>
                                                        layer.id !==
                                                        "filtered-by-expiration-year-mjerna-mjesta-layer"
                                                )
                                            );
                                        }
                                    }}
                                />
                                <span className="slider"></span>
                            </label>

                            {showSealExpiryYearSlider && (
                                <div className="slider-container">
                                    <Slider
                                        range
                                        min={1950}
                                        max={currentYear}
                                        step={1}
                                        value={sealExpiryYearRange}
                                        onChange={(value) => {
                                            handleChange(value, setSealExpiryYearRange);
                                            filterByExpirationYear(wfsLayers, sealExpiryYearRange, setWfsLayers);
                                        }}
                                        trackStyle={[{ backgroundColor: "#00ffcc" }]}
                                        handleStyle={[
                                            { backgroundColor: "#fff", borderColor: "#ccc" },
                                            { backgroundColor: "#fff", borderColor: "#ccc" },
                                        ]}
                                        railStyle={{ backgroundColor: "#34495e" }}
                                    />

                                    <div className="labels">
                                        <span>{sealExpiryYearRange[0]}</span>
                                        <span>{sealExpiryYearRange[1]}</span>
                                    </div>
                                </div>
                            )}
                        </div>

                        <label className="toggle">
                            <span>Energetska kartica</span>
                            <input
                                type="checkbox"
                                checked={isEnergetskaKarticaActive}
                                onChange={(e) => {
                                    setIsEnergetskaKarticaActive(e.target.checked);
                                    if (!e.target.checked) {
                                        setWfsLayers(prevLayers =>
                                            prevLayers.filter(
                                                layer => !layer.id.includes("-energetska-kartica-layer")
                                            )
                                        );
                                    }
                                }}
                            />
                            <span className="slider"></span>
                        </label>

                        {isEnergetskaKarticaActive && (
                            <EnergyCard wfsLayers={wfsLayers} setWfsLayers={setWfsLayers} />
                        )}

                        <label className="toggle">
                            <span>Očitanja</span>
                            <input
                                type="checkbox"
                                checked={isOcitanjaActive}
                                onChange={(e) => {
                                    setIsOcitanjaActive(e.target.checked);
                                    if (!e.target.checked) {
                                        setWfsLayers(prevLayers =>
                                            prevLayers.filter(
                                                layer =>
                                                    layer.id !== "rucno-ocitanja-layer" &&
                                                    layer.id !== "amm-ocitanja-layer"
                                            )
                                        );
                                    }
                                }}
                            />
                            <span className="slider"></span>
                        </label>

                        {isOcitanjaActive && (
                            <Readings wfsLayers={wfsLayers} setWfsLayers={setWfsLayers} />
                        )}

                        <label className="toggle">
                            <span>Očitački hodovi (OH)</span>
                            <input
                                type="checkbox"
                                checked={wfsLayers.some(layer => layer.id.startsWith("ocitacki_hod"))}
                                onChange={(e) => {
                                    toggleLayer(e.target.checked, "ocitacki_hod");
                                    setIsOhActiveExtern(e.target.checked);
                                }}
                            />
                            <span className="slider"></span>
                        </label>
                    </div>
                )}
            </div>
        </div>
    );
}

export default LowVoltage;